import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment.prod';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from './auth-service.service';
import { catchError, map, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  get _liveApiUrl() {
    return this.authService._liveApiUrl;
  }
  port = environment.port;
  apiUrl = environment.apiUrl;
  constructor(
    private http: HttpClient,
    public authService: AuthServiceService) { }

   getAdminSentNotificationList(
  tabName: string,
  searchVal: string,
  page: any
): Observable<any> {

  let params = new URLSearchParams();

  if (tabName === 'all') {
      tabName = '';
  }

  if (tabName && tabName.length > 0) {
      if (tabName == 'customers') {
          tabName = 'Customer';
      }
      if (tabName == 'drivers') {
          tabName = 'Driver';
      }
      params.set('notif_type', tabName);
  }

  if (searchVal && searchVal.length > 0) {
      params.set('search_text', searchVal);
  }

  if (page) {
      params.set('page', page);
  }

  let tail = params.toString() ? `?${params.toString()}` : '';

  return this.http
      .get<any>(`${this.authService._liveApiUrl}/notification/admin-notification-listing/${tail}`)
      .pipe(
          switchMap((data: any) => {

              // 👇 Main Fix Logic
              if (data?.errorMessage === "Invalid page number" && page > 1) {
                localStorage.setItem('NotificationPage',String(page-1));
                  console.log("Empty page detected, loading previous page...");

                  return this.getAdminSentNotificationList(tabName, searchVal, page - 1);
              }

              return of(data);
          }),
          catchError(this.authService.handleError)
      );
}

  clearAdminNotification(formData:any){
    return this.http
      .put<any>(`${this.authService._liveApiUrl}/notification/clear-admin-notification/`,formData)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
  }
  clearAdminNotifications(type: string) {

  let url = `${this.authService._liveApiUrl}/notification/clear-admin-notification/all/`;

  if (type === 'customers') {
    url += `?notif_type=Customer`;
  } else if (type === 'drivers') {
    url += `?notif_type=Driver`;
  }
  // type === 'all' hoga to plain URL hi chalega

  return this.http.put<any>(url, {}).pipe(
    map((data) => data),
    catchError(this.authService.handleError)
  );
}
  sendGenericNotification(formData:any) {
    return this.http
      .post<any>(`${this.authService._liveApiUrl}/notification/send-notification/`,formData)
  }
}
